<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-bar-chart"></span>{{ 'bikeshop.menu.dashboard' | translate }}</div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </div>
  <div>

    <div class="row">
      <div class="col-xl-12 col-lg-12 margin-bottom-32">
        <p-card class="short">
          <div>
            <div class="sub-header flex">service-level agreements</div>
            <div class="row">
              <div class="col-xl-12 col-lg-12">
                <div style="text-align: center;"><span
                  class="sub-header">{{'dashboard.waiting_for' | translate }}:</span></div>
              </div>
              <div class="col-xl-12 col-lg-12">
                <div class="container-slas">
                  <div class="tabs">
                    <input type="radio" id="radio-0" name="tabs" checked
                           style="display:none !important"/>
                    <label class="tab" for="radio-0" style="display:none !important"><span
                      class="notification">0</span></label>
                    <input type="radio" id="radio-1" name="tabs" (change)="filterSLAs(1)"/>
                    <label class="tab"
                           for="radio-1">{{'dashboard.parts_longer_than_x' | translate }}<span
                      class="notification">{{jobCardsListIDOne.length}}</span></label>
                    <input type="radio" id="radio-2" name="tabs" (change)="filterSLAs(2)"/>
                    <label class="tab"
                           for="radio-2">{{'dashboard.clients_longer_than_x' | translate }}<span
                      class="notification">{{jobCardsListIDTwo.length}}</span></label>
                    <input type="radio" id="radio-3" name="tabs" (change)="filterSLAs(3)" checked/>
                    <label class="tab" for="radio-3">{{'dashboard.work_longer_than_x' | translate }}
                      <span class="notification">{{jobCardsListIDThree.length}}</span></label>
                    <input type="radio" id="radio-4" name="tabs" (change)="filterSLAs(4)"/>
                    <label class="tab"
                           for="radio-4">{{'dashboard.pickup_longer_than_x' | translate }}<span
                      class="notification">{{jobCardsListIDFour.length}}</span></label>
                    <input type="radio" id="radio-5" name="tabs" (change)="filterSLAs(5)"/>
                    <label class="tab"
                           for="radio-5">{{'dashboard.work_past_scheduled_date' | translate }}<span
                      class="notification">{{jobCardsListIDFive.length}}</span></label>
                    <span class="glider"></span>
                  </div>
                </div>
                <div class="label" *ngIf="selectedTab==1">
                  *{{'dashboard.suggest_we_suggest' | translate}}
                  : {{'dashboard.suggestion_parts'| translate}}</div>
                <div class="label" *ngIf="selectedTab==2">
                  *{{'dashboard.suggest_we_suggest' | translate}}
                  : {{'dashboard.suggestion_client'| translate}}</div>
                <div class="label" *ngIf="selectedTab==3">
                  *{{'dashboard.suggest_we_suggest' | translate}}
                  : {{'dashboard.suggestion_work'| translate}}</div>
                <div class="label" *ngIf="selectedTab==4">
                  *{{'dashboard.suggest_we_suggest' | translate}}
                  : {{'dashboard.suggestion_complete'| translate}}</div>
                <div class="label" *ngIf="selectedTab==5">
                  *{{'dashboard.suggest_we_suggest' | translate}}
                  : {{'dashboard.suggest_past'| translate}}</div>
              </div>
              <div *ngIf="loadingSLA">
                <p-progressSpinner [style]="{width: '30px', height: '30px'}" animationDuration=".5s">
                </p-progressSpinner>
              </div>
              <div class="col-xl-12 col-lg-12" *ngIf="jobCardsFiltered.length > 0 && !loadingSLA">
                <div>
                  <p-table #jobCardsTable [columns]="openColumns" [value]="jobCardsFiltered"
                           [showLoader]="true" [paginator]="true" [rows]="5">
                    <ng-template pTemplate="header" let-columns>
                      <tr>
                        <th style="width: 10px"></th>
                        <th *ngFor="let col of columns"
                            [pSortableColumn]="col.type !== 'action' ? col.field : ''"
                            [ngStyle]="{'width': col.type === 'action' ? '215px' : 'auto'}">
                          {{ col.header }}
                          <p-sortIcon [field]="col.field" style="vertical-align: middle;"
                                      *ngIf="col.type !== 'action'">
                          </p-sortIcon>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-jobcard let-columns="columns">
                      <tr [pSelectableRow]="jobcard">
                        <td style="display: flex;">
                          <div class="status-indicator" ngClass=""></div>
                        </td>
                        <td *ngFor="let col of columns">
                          <div *ngIf="col.type == 'jobcardno'">
                            <div (click)="openJobCard(jobcard.ID)">
                              <u>
                                {{ jobcard[col.field] }}
                              </u>
                            </div>
                          </div>
                          <div *ngIf="col.type !== 'action' && col.type !== 'jobcardno'">
                            {{jobcard[col.field]}}
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </div>
    </div>


    <div class="row">
      <div class="col-xl-8 col-lg-7 margin-bottom-32">
        <p-card>
          <div>
            <div class="sub-header flex">{{ 'bikeshop.dashboard.completed_service_history' | translate }}</div>
            <div class="chart-services">
              <canvas style="height:300px;" baseChart [legend]="false" [height]="170"
                      [datasets]="servicesHistory.data" [labels]="servicesHistory.labels"
                      chartType="roundedBar"></canvas>
            </div>
          </div>
        </p-card>
      </div>
      <div class="col-xl-4 col-lg-5 margin-bottom-32">
        <p-card>
          <div>
            <div class="sub-header flex">{{ 'bikeshop.dashboard.daily_workshop_summary' | translate }}</div>
            <div class="due-subheader">
              <span class="fa fa-chevron-left" (click)="dailyWorkshopSummaryBack()"></span>
              <span>{{ dailyWorkshopDate | date : 'd MMMM yyyy' }}</span>
              <span class="fa fa-chevron-right" *ngIf="today !== dailyWorkshopDate"
                    (click)="dailyWorkshopSummaryForward()"></span>
            </div>
            <div *ngIf="dailyWorkshopSummary">
              <div class="daily-summary">
                <div>
                  <div class="daily-metric">
                    {{dailyWorkshopSummary.onlineBookings}}
                  </div>
                  <div class="daily-label">
                    <div>{{ 'bikeshop.dashboard.online_bookings' | translate }}</div>
                  </div>
                </div>
                <div>
                  <div class="daily-metric">
                    {{dailyWorkshopSummary.appBookings}}
                  </div>
                  <div class="daily-label">
                    <div>{{ 'bikeshop.dashboard.app_bookings' | translate }}</div>
                  </div>
                </div>
                <div>
                  <div class="daily-metric">
                    {{dailyWorkshopSummary.portalBookings}}
                  </div>
                  <div class="daily-label">
                    <div>{{ 'bikeshop.dashboard.portal_bookings' | translate }}</div>
                  </div>
                </div>
                <div>
                  <div class="daily-metric">
                    {{dailyWorkshopSummary.jobsCompleted}}
                  </div>
                  <div class="daily-label">
                    <div>{{ 'bikeshop.dashboard.jobs_completed' | translate }}</div>
                  </div>
                </div>
                <div>
                  <div class="daily-metric">
                    {{dailyWorkshopSummary.revenueGenerated}}
                  </div>
                  <div class="daily-label">
                    <div>{{ 'bikeshop.dashboard.revenue' | translate }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </div>
      <!-- <div class="col-xl-5 col-lg-6 margin-bottom-32">
      <p-card>
        <div>
          <div class="sub-header flex">{{ 'bikeshop.dashboard.due_for_service' | translate }}</div>
          <div class="due-subheader"><span>{{servicesDueSummary.NoBikes}}</span> out of
            {{dashboardInfo.LinkedBikes_Count}}</div>

          <div style="display: flex;">
            <div class="due-container-left">
              <div id="cont" [attr.data-pct]="dueVal">
                <svg id="svg" width="200" height="200" viewPort="0 0 100 100" version="1.1"
                  xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient _ngcontent-fub-c6="" id="Gradient" x1="0.5" x2="0.1" y1="0.85" y2="0">
                      <stop _ngcontent-fub-c6="" offset="0%" stop-color="#b32e51"></stop>
                      <stop _ngcontent-fub-c6="" offset="25%" stop-color="#ee3158"></stop>
                      <stop _ngcontent-fub-c6="" offset="50%" stop-color="#ee3158"></stop>
                      <stop _ngcontent-fub-c6="" offset="70%" stop-color="#ee3158"></stop>
                      <stop _ngcontent-fub-c6="" offset="80%" stop-color="#ee3158"></stop>
                    </linearGradient>
                  </defs>
                  <circle r="70" cx="100" cy="100" fill="transparent" stroke="rgba(196,196,196,0.2)"
                    stroke-dasharray="565.48" stroke-dashoffset="0"></circle>
                  <circle id="bar" r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48"
                    transform="rotate(-90 100 100)" stroke-dashoffset="0" stroke="url(#Gradient)"
                    [ngStyle]="{'stroke-dashoffset': dueScore+'px'}" stroke-linecap="round"></circle>
                </svg>
              </div>
            </div>
            <div class="due-container-right">
              <div>
                <div class="due-metric">
                  {{servicesDueSummary.DueByHour}}
                </div>
                <div class="due-label">
                  <a
                    [routerLink]="[ '/store/dashboard/', BASED_ON_HOURS ]">{{ 'bikeshop.dashboard.based_on_hours' | translate }}</a>
                </div>
              </div>
              <div>
                <div class="due-metric">
                  {{servicesDueSummary.DueByKM}}
                </div>
                <div class="due-label">
                  <a
                    [routerLink]="[ '/store/dashboard/', BASED_ON_KILOMETERS ]">{{ 'bikeshop.dashboard.based_on_distance' | translate }}</a>
                </div>
              </div>
              <div>
                <div class="due-metric">
                  {{servicesDueSummary.DueByDate}}
                </div>
                <div class="due-label">
                  <a
                    [routerLink]="[ '/store/dashboard/', BASED_ON_MONTH_INTERVAL ]">{{ 'bikeshop.dashboard.based_on_month_intervals' | translate }}</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </p-card>
    </div> -->
    </div>


    <div class="row">
      <div class="col-xl-6 col-lg-12 margin-bottom-32">
        <p-card>
          <div>
            <div class="sub-header flex" style="position: relative; display: flex;">
              {{ 'bikeshop.dashboard.service_ratings' | translate }}
              <div class="rating-average" *ngIf="ratingSummary.AvgRating>0">
                <div>
                  <span>{{ratingSummary.AvgRating | number : '.1-1'}} {{ 'bikeshop.dashboard.avg' | translate }}</span>
                  <hubtiger-star-rating noStars="5" [rating]="ratingSummary.AvgRating"
                                        colour="#252B40">
                  </hubtiger-star-rating>
                </div>
                <!--<div class="average">Average</div>-->
              </div>
            </div>
            <div class="dashboard-ratings">
              <div *ngIf="lastestRatings && lastestRatings.length===0">
                {{ 'bikeshop.dashboard.no_ratings' | translate }}
              </div>
              <div *ngFor="let cyclist of lastestRatings; let i = index" class="rating">
                <avatar style="margin-bottom: auto; margin-top:auto; margin-right: 8px;" size=38
                        name="{{cyclist.Cyclist}}" profilePhoto="{{cyclist.ProfileImage}}"></avatar>
                <div class="rating-detail">
                  <div class="rating-name">
                    <span style="cursor: pointer;text-decoration: underline;"
                          (click)="editUser(cyclist.UserID)">{{cyclist.Cyclist}}</span> for <span
                    class="rating-service">{{cyclist.SelectedServices}}</span>
                  </div>
                  <div class="rating-date">
                    {{cyclist.DateCheckedIn | date : 'fullDate'}} -
                    {{ 'bikeshop.dashboard.jobcard' | translate }}: {{cyclist.JobCard}}
                  </div>
                  <div class="rating-feedback"
                       *ngIf="cyclist.Feedback && cyclist.Feedback.length > 0">
                    <q>{{cyclist.Feedback}}</q>
                  </div>
                </div>
                <div class="rating-right">
                  <span>{{cyclist.Rating}}</span>
                  <hubtiger-star-rating noStars="5" [rating]="cyclist.Rating"
                                        colour="#252B40"></hubtiger-star-rating>
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </div>
      <div class="col-xl-6 col-lg-12 margin-bottom-32">
        <p-card>
          <div>
            <div class="sub-header flex">{{ 'bikeshop.dashboard.technician_leaderboard' | translate }}</div>
            <div class="dashboard-technicians">
              <div *ngIf="topTechnicians.length===0 && !loadingTechnicians">
                {{ 'bikeshop.dashboard.no_technicians_or_services' | translate }}
              </div>
              <div *ngFor="let technician of topTechnicians; let i = index" class="technician">
                :
                <div
                  class="position">{{i + 1}}{{i + 1 === 1 ? 'st' : i + 1 === 2 ? 'nd' : i + 1 === 3 ? 'rd' : 'th'}}</div>
                <avatar style="margin-top: auto; margin-top:auto; margin-right: 8px;" size=34
                        name="{{technician.Technician}}"
                        profilePhoto="{{technician.ImageFilename}}"></avatar>
                <div class="technician-name">{{technician.Technician}}</div>
                <div class="technician-right">
                  <span class="technician-services">{{technician.NumberCompletedServices}}</span>
                  {{ 'bikeshop.dashboard.services' | translate }}
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </div>
    </div>


    <div class="row">
      <div class="col-xl-12 col-lg-12 margin-bottom-32">
        <p-card class="short">
          <div>
            <div class="sub-header flex">{{ 'bikeshop.dashboard.configuration_overview' | translate }}</div>
            <div>
              <app-configuration-overview
                [linkedCyclists]="linkedCyclistsValue"></app-configuration-overview>
            </div>
          </div>
        </p-card>
      </div>
    </div>


    <!--<div class="row">
      <div class="col-xl-5 col-lg-12 margin-bottom-32">
        <p-card>
          <div>
            <div class="sub-header flex">{{ 'bikeshop.dashboard.sales_history' | translate }}</div>
            <div class="margin-top-16">Place holder for some graph or other metric</div>
          </div>
        </p-card>
      </div>

      <div class="col-xl-7 col-lg-12 margin-bottom-32">
        <p-card>
          <div>
            <div class="sub-header flex" style="position: relative">
              {{ 'bikeshop.dashboard.linked_cyclists_leaderboard' | translate }}
            </div>
            <div class="cyclists">
              <div *ngIf="linkedCyclists.length===0 && !loadingCyclistsRides">
                {{ 'bikeshop.dashboard.no_cyclists_on_leaderboard' | translate }}
              </div>
              <div *ngIf="loadingCyclistsRides">
                <p-progressSpinner [style]="{width: '30px', height: '30px'}" animationDuration=".5s">
                </p-progressSpinner>
              </div>
              <div class="cyclist" *ngFor="let cyclist of linkedCyclists; let i = index;">
                <div class="position">{{i+1}}{{i+1===1 ? 'st' : i+1===2 ? 'nd' : i+1===3 ? 'rd' : 'th'}}</div>
                <avatar style="margin-top: auto; margin-top:auto; margin-right: 8px;" size=34 name="{{cyclist.Cyclist}}"
                        profilePhoto="{{cyclist.ProfileImage}}"></avatar>
                <div class="cyclist-name">
                  <span style="cursor: pointer;text-decoration: underline;"
                        (click)="editUser(cyclist.UserID)">{{cyclist.Cyclist}}</span>
                </div>
                <div class="cyclist-right">
                  <span>{{cyclist.Distance | number : '.0-0'}} {{distanceMetric}}</span>
                  {{ 'bikeshop.dashboard.cycled_this_month' | translate }}
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </div>
    </div>-->

  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
